/**
 * How the orbit view treats walls — the three states of the round button above the
 * walk/orbit switch, in the order it cycles through them.
 *
 *   full     every wall at its real height
 *   cutaway  the Sims rule: walls standing between the camera and a room drop to waist
 *            height, walls seen from inside stay up — re-judged as the camera orbits
 *   low      every wall at waist height, the native «низкие стены»
 */
import { t } from '../i18n/I18n';

export type WallMode = 'full' | 'cutaway' | 'low';

export const WALL_MODES: readonly WallMode[] = ['full', 'cutaway', 'low'];

/** What the button shows right now. */
export const WALL_MODE_LABELS: Readonly<Record<WallMode, string>> = {
  get full() { return t('#WallModeFull'); },
  get cutaway() { return t('#WallModeCutaway'); },
  get low() { return t('#WallModeLow'); },
};

/** The mode on screen, as the tooltip names it (Figma «Navigation · Bottom»). */
export const WALL_MODE_TIPS: Readonly<Record<WallMode, string>> = {
  get full() { return t('#WebTipWallsUp'); },
  get cutaway() { return t('#WebTipCutaway'); },
  get low() { return t('#WebTipWallsDown'); },
};

export function nextWallMode(mode: WallMode): WallMode {
  return WALL_MODES[(WALL_MODES.indexOf(mode) + 1) % WALL_MODES.length];
}

/** A stored value, or the pre-2026-09 `lowWalls` flag, or whatever the caller defaults to. */
export function parseWallMode(value: unknown, legacyLowWalls?: unknown): WallMode {
  if (value === 'full' || value === 'cutaway' || value === 'low') return value;
  return legacyLowWalls === true ? 'low' : 'full';
}
